<form
  (ngSubmit)="onSubmit()"
  [formGroup]="applianceForm"
  appFormSubmit
  class="appliance-details-form"
>
  @for (
    appliance of numberedAppliances();
    track appliance.applianceCode;
    let index = $index
  ) {
    <app-card class="appliance-details-form__card">
      <fieldset
        [formGroupName]="appliance.applianceCode"
        class="appliance-details-form__fieldset"
      >
        <legend class="appliance-details-form__legend">
          {{ appliance.displayTitle }}
        </legend>

        <app-form-field
          [appFormField]="formFields.manufacturer"
          class="appliance-details-form__field"
          formControlName="manufacturer"
        >
          <app-form-select
            [fill]="true"
            [options]="brandsByApplianceCode()[appliance.applianceCode]"
          />
        </app-form-field>

        <app-form-field
          [appFormField]="formFields.purchasePrice"
          class="appliance-details-form__field"
          formControlName="purchasePrice"
        >
          <app-form-select [options]="priceBands" />
        </app-form-field>

        <app-form-field
          [appFormField]="formFields.wasBoughtWithin12Months"
          formControlName="wasBoughtWithin12Months"
        >
          <app-form-radio
            [isBinary]="true"
            [name]="`wasBoughtWithin12Months${appliance.applianceCode}`"
            [size]="'large'"
          />
        </app-form-field>

        @if (radioFormFieldHasValue()(appliance.applianceCode)) {
          <p class="appliance-details-form__field-label">
            {{ "APPLIANCE_DETAILS_FORM_PURCHASE_DATE_LABEL" | translate }}
          </p>
        }

        <div class="appliance-details-form__purchase-date">
          @if (showMonthFormField()(appliance.applianceCode)) {
            <app-form-field
              [appFormField]="formFields.purchaseMonth"
              formControlName="purchaseMonth"
            >
              <app-form-select
                [options]="createMonthOptions(appliance.applianceCode)"
              />
            </app-form-field>
          }

          @if (radioFormFieldHasValue()(appliance.applianceCode)) {
            <app-form-field
              [appFormField]="formFields.purchaseYear"
              formControlName="purchaseYear"
            >
              <app-form-select
                [options]="
                  createYearOptions(
                    showMonthFormField()(appliance.applianceCode)
                  )
                "
              />
            </app-form-field>
          }
        </div>
      </fieldset>
    </app-card>
  }

  <div class="appliance-details-form__link">
    <app-link
      (click)="onChangeAppliancesClick()"
      [navigationLink]="{
        label: 'APPLIANCE_DETAILS_FORM_CTA_CHANGE_APPLIANCES' | translate,
        routerPath: '/multi-plan/protection-details',
      }"
    />
  </div>

  <app-form-submit-button [fill]="true" [loading]="formSubmitted">{{
    "APPLIANCE_DETAILS_FORM_CTA_CONTINUE" | translate
  }}</app-form-submit-button>
</form>
